import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

export default function Welcome() {
  return (
    <div style={{ minHeight: "100vh", background: "#2C2C2C", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}>
      <div style={{ textAlign: "center", maxWidth: "400px" }}>
        <div style={{ width: "80px", height: "80px", background: "#C9A84C", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 24px", fontSize: "36px" }}>
          ✓
        </div>
        <h1 style={{ fontSize: "28px", fontWeight: 800, color: "white", marginBottom: "12px" }}>
          Welcome to <span style={{ color: "#C9A84C" }}>TaxThinker</span>
        </h1>
        <p style={{ color: "#909090", fontSize: "15px", lineHeight: "1.7", marginBottom: "32px" }}>
          You have successfully logged in. Your smart CA tax tools are ready to use.
        </p>
        <Link to="/dashboard" style={{ background: "#C9A84C", color: "#2C2C2C", padding: "14px 36px", borderRadius: "10px", fontWeight: 700, fontSize: "16px", textDecoration: "none", display: "inline-block" }}>
          Go to TaxThinker
        </Link>
      </div>
    </div>
  );
}
